import React from "react";
import Button from './Button';
import GithubColorIcon from './github-color.svgc';
import GoogleColorIcon from './google-color.svgc';
import './SignupButton.css';
import {gotoSignup, gaEvent} from '../utils/ga';


export default function SignupButton(props) {
  return <Button onClick={gotoSignup} className="Button-With-Helpers">
    Signup now for free
    <div className="Login-Button-Helpers">
      Login with <GithubColorIcon /> <GoogleColorIcon />
    </div>
  </Button>
}


// WEBPACK FOOTER //
// ./src/components/SignupButton.js